var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTent(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 26,
    viewBox: "0 0 40 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.6124 22.9256C33.2818 23.4682 22.8944 17.598 20.267 7.34536V22.9857H1.88087C2.18289 21.3061 2.59389 19.7108 2.73283 18.0922C2.94998 15.5629 3.01238 13.0176 3.07478 10.4783C3.08976 9.85635 3.17711 9.53163 3.83855 9.33629C9.41287 7.69179 14.5779 5.14573 19.4142 1.93102C20.0524 1.50612 20.4867 1.5537 21.0965 1.9569C25.9445 5.15324 31.1087 7.69346 36.6797 9.35799C37.1231 9.49072 37.4667 9.58672 37.4243 10.1978C37.1356 14.4109 37.5907 18.5555 38.6099 22.6451C38.6219 22.7381 38.6228 22.8323 38.6124 22.9256V22.9256Z",
    stroke: "black",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTent);
export default __webpack_public_path__ + "static/media/tent.47b118b3df9a6b7683d18d1012e7ba45.svg";
export { ForwardRef as ReactComponent };